import React from "react";

const ContactsPhone = (
    {
        className
    }
) => {
    return (
        (<svg
            className={className}
            width="1em"
            height="1em"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0ZM43.7142 42.5439V38.148C43.7321 37.4294 43.4851 36.7293 43.0205 36.1809C42.5558 35.6324 41.9057 35.2739 41.1939 35.1735C39.7871 34.988 38.4059 34.6439 37.0764 34.1478C36.552 33.9506 35.982 33.908 35.434 34.0248C34.886 34.1417 34.3831 34.4132 33.9847 34.8072L32.1237 36.6681C28.4553 34.5822 25.4179 31.5448 23.332 27.8763L25.1929 26.0154C25.5869 25.617 25.8584 25.114 25.9752 24.5661C26.0921 24.0181 26.0494 23.4481 25.8523 22.9236C25.3562 21.5942 25.0121 20.2129 24.8266 18.8062C24.727 18.102 24.3749 17.4581 23.8357 16.9944C23.2965 16.5307 22.6071 16.2788 21.896 16.2858H17.5001C17.0932 16.2862 16.6909 16.3713 16.3188 16.5357C15.9466 16.7001 15.6127 16.9402 15.3384 17.2407C15.0641 17.5411 14.8554 17.8955 14.7256 18.281C14.5957 18.6666 14.5475 19.075 14.5842 19.4802C15.0651 24.0094 16.6062 28.3616 19.0826 32.1843C21.3323 35.7247 24.334 38.7263 27.8744 40.9761C31.6798 43.4438 36.0109 44.9846 40.5199 45.4745C40.9263 45.5113 41.3359 45.4627 41.7225 45.332C42.1091 45.2012 42.4641 44.9912 42.7648 44.7153C43.0655 44.4394 43.3053 44.1038 43.4688 43.7299C43.6323 43.356 43.7159 42.952 43.7142 42.5439Z"
                fill="currentColor" />
        </svg>)
    );
};

export default ContactsPhone;